import { gql } from "gql";

export const HIDDEN_FRAGMENT = gql(/* GraphQL */ `
  fragment Hidden on Hidden {
    hidden
    instanceName
  }
`);
